<app-page-header header="agent-remote-success.title" />

<ng-container [ngSwitch]="calculationToClientConfirmState$ | async">
  <qbe-panel-component *ngSwitchCase="apiState.success" class="success">
    <div class="page-container">
      <div class="success-container">
        <div class="success-summary">
          <h2 nxHeadline="section" class="success-headline">
            {{ 'agent-remote-success.header' | translate : (calculationToClientConfirmData$ | async) }}
          </h2>
          <p nxCopytext="normal" class="success-copy" [innerHTML]="'agent-remote-success.summary' | translate : (calculationToClientConfirmData$ | async) | markdown"></p>
        </div>

        <section class="success-offer">
          <figure class="success-illustration">
            <qbe-illustration name="clientAndAgentShakingHands"></qbe-illustration>
          </figure>
        </section>
      </div>
    </div>
  </qbe-panel-component>

  <app-error *ngSwitchCase="apiState.error" [appError]="calculationToClientConfirmError$ | async" />
  <app-loader *ngSwitchCase="apiState.pending" view="policy" />
  <app-loader *ngSwitchDefault view="fixed" />
</ng-container>
